
import React from "react";
import { PageLayout } from "@/components/PageLayout";
import { Card } from "@/components/ui/card";
import { FeedbackSection } from "@/components/FeedbackSection";
import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";
import { ToolUsageWrapper } from "@/components/ToolUsageWrapper";

interface PageLayoutProps {
  children: React.ReactNode;
  title: React.ReactNode;
  description: string;
  breadcrumbs?: { label: string; path: string }[];
  reliabilityLevel?: 1 | 2 | 3 | 4 | 5;
}

interface ToolLayoutProps extends Omit<PageLayoutProps, 'children'> {
  children: React.ReactNode;
  toolName: string;
  feedbackSectionProps?: {
    enabled?: boolean;
  };
  maxWidth?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl" | "5xl" | "6xl" | "7xl" | "full";
  badge?: React.ReactNode;
  className?: string;
}

export const ToolLayout: React.FC<ToolLayoutProps> = ({
  children,
  toolName,
  feedbackSectionProps = { enabled: true },
  maxWidth = "full", // Changé la valeur par défaut à "full"
  badge,
  className,
  ...pageLayoutProps
}) => {
  const maxWidthClasses = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-xl",
    "2xl": "max-w-2xl",
    "3xl": "max-w-3xl",
    "4xl": "max-w-4xl",
    "5xl": "max-w-5xl",
    "6xl": "max-w-6xl",
    "7xl": "max-w-7xl",
    full: "max-w-full", // Modifié de max-w-[1500px] à max-w-full
  };

  return (
    <PageLayout {...pageLayoutProps}>
      <ToolUsageWrapper toolName={toolName}>
        <div className={cn(`w-full ${maxWidthClasses[maxWidth]} mx-auto px-0 relative`, className)}>
          {badge && (
            <div className="absolute top-0 right-0 z-10">
              {badge}
            </div>
          )}
          
          {children}
        </div>
      </ToolUsageWrapper>
      
      {/* Add feedback section outside the main content area */}
      {feedbackSectionProps.enabled && (
        <div className="w-full max-w-full mx-auto mt-6 sm:mt-12 p-2 sm:p-4">
          <FeedbackSection toolName={toolName} />
        </div>
      )}
    </PageLayout>
  );
};
